import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Button, Checkbox } from "rhombus-react";
import PropTypes from "prop-types";

import BasicModal from "widgets/modals/BasicModal";

import "./AssignNewContentFeed.css";

const DATA_SOURCE_OPTIONS = {
	SOURCE_URL: "source_url",
	GENERATE_GSHEET: "generate_gsheet",
};

function AssignNewContentFeed(props) {
	const history = useHistory();
	const {
		creativeIds,
		creativeName,
		libraryId,
		onClose,
	} = props;

	const [dataSource, setDataSource] = useState(DATA_SOURCE_OPTIONS.SOURCE_URL);

	const targetCreativeIds = creativeIds || [];

	const ROUTE_BY_SOURCE = {
		[DATA_SOURCE_OPTIONS.SOURCE_URL]: `/library/${libraryId}/content-feeds/assign`,
		[DATA_SOURCE_OPTIONS.GENERATE_GSHEET]: `/library/${libraryId}/content-feeds/assign-blank`,
	};

	const handleProceed = (e) => {
		e.preventDefault();
		const targetRoute = ROUTE_BY_SOURCE[dataSource];
		if (!targetRoute) {
			return;
		}
		onClose();
		history.push(targetRoute, {
			creativeIds: targetCreativeIds,
			creativeName,
		});
	};

	const renderContent = () => (
		<form className="assign-new-content-feed-form" onSubmit={handleProceed}>
			<div className="assign-new-content-feed-question">
				<label>How would you like to provide the data? <span style={{ color: 'red' }}>*</span></label>
			</div>
			<div className="radio-options">
				<div>
					<Checkbox
						type="radio"
						label="I have my own source URL"
						value={DATA_SOURCE_OPTIONS.SOURCE_URL}
						checked={dataSource === DATA_SOURCE_OPTIONS.SOURCE_URL}
						onChange={e => setDataSource(e.target.value)}
					/>
				</div>
				<div>
					<Checkbox
						type="radio"
						label="Generate a new GSheet based on variables for me"
						value={DATA_SOURCE_OPTIONS.GENERATE_GSHEET}
						checked={dataSource === DATA_SOURCE_OPTIONS.GENERATE_GSHEET}
						onChange={e => setDataSource(e.target.value)}
					/>
				</div>
			</div>
		</form>
	);

	const renderFooter = () => ([
		<Button key="back" theme="grey" onClick={onClose}>Back</Button>,
		<Button
			key="proceed"
			theme="blue"
			disabled={!dataSource}
			onClick={handleProceed}
		>
			Continue
		</Button>
	]);

	const modalProps = {
		title: `Assign a New Bulk Sheet - ${creativeName}`,
		onClose,
		renderContent,
		renderFooter,
	};

	return <BasicModal {...modalProps} />;
}

AssignNewContentFeed.propTypes = {
	creativeIds: PropTypes.arrayOf(PropTypes.number).isRequired,
	creativeName: PropTypes.string.isRequired,
	libraryId: PropTypes.number.isRequired,
	onClose: PropTypes.func.isRequired,
};

AssignNewContentFeed.displayName = "AssignNewContentFeed";

export default AssignNewContentFeed;
